import { insert } from './common'
import { visitListStatuses, visitListStatusesEncrypted } from './constants'
import VisitFilter from '../pages/Visits/visits-table-title-filter-layout/visit-filter/VisitFilter'
import StatusFilter from '../pages/Visits/visits-table-title-filter-layout/status-filter/StatusFilter'
import { VisitsDateFilter } from '../pages/Visits/visits-date-filter/VsistsDateFilter'
import TagsFilter from '../pages/Visits/visits-table-title-filter-layout/tag-filter/TagFilter'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateStyleObjectForTableColumn = (columnName, isColumnTitles, isPast) => {
  switch (columnName) {
    case 'BookingId':
      return { whiteSpace: 'nowrap', overflow: 'hidden', width: 168 }
    case 'Date':
      return { whiteSpace: 'nowrap', width: 175 }
    case 'Visit':
      return { width: isPast ? 217 : 196, flex: 0.25 }
    case 'Patient':
      return { width: isPast ? 325 : 300, flex: 0.4 }
    case 'Tags':
      return { width: 255, minWidth: 255, flex: 0.2, flexWrap: 'wrap' }
    case 'Remarks':
      return { width: 132, paddingLeft: 0 }
    case 'Screening':
      return { width: 185 }
    case 'Status':
      return { width: isPast ? 211 : 257, flex: 0.35 }
    default:
      break
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateStyleObjectForTableColumnSpan = (columnName, isColumnTitles) => {
  switch (columnName) {
    case 'BookingId':
      return { whiteSpace: 'nowrap', overflow: 'hidden', width: 168 }
    case 'Date':
      return { whiteSpace: 'nowrap', overflow: 'hidden', width: 168 }
    case 'Visit':
      return isColumnTitles ?
          {}
        : { paddingLeft: 0, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }
    case 'Patient':
      return isColumnTitles ?
          {}
        : {
            cursor: 'pointer',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }
    case 'Remarks':
      return isColumnTitles ?
          { overflow: 'hidden' }
        : {
            paddingLeft: 0,
            alignItems: 'center',
            textAlign: 'center',
            width: 132,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            display: 'flex',
            justifyContent: 'center',
          }
    case 'Status':
      return isColumnTitles ? {} : { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }
    case 'Screening':
      return isColumnTitles ? {} : { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginLeft: 0 }
    default:
      break
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateTableList = (type, isColumnTiles, isPast) => {
  const commonVisitColumnsList = [
    {
      name: 'Booking ID',
      additionalContainerStyle: generateStyleObjectForTableColumn('BookingId', isColumnTiles, isPast),
      additionalSpanStyle: generateStyleObjectForTableColumnSpan('BookingId', isColumnTiles),
      isWithFilter: false,
      isShowFilterComponent: false,
      isFilterActive: false,
    },
    {
      name: 'Date',
      additionalContainerStyle: generateStyleObjectForTableColumn('Date', isColumnTiles, isPast),
      additionalSpanStyle: generateStyleObjectForTableColumnSpan('Date', isColumnTiles),
      isWithFilter: false,
      isShowFilterComponent: false,
      isFilterActive: false,

      hasFilter: true,
      filterSvgIcon: 'filter',
      VisitsFilter: VisitsDateFilter,
    },
    {
      name: 'Visit',
      additionalContainerStyle: generateStyleObjectForTableColumn('Visit', isColumnTiles, isPast),
      additionalSpanStyle: generateStyleObjectForTableColumnSpan('Visit', isColumnTiles),
      isWithIcon: true,
      isWithFilter: true,
      isShowFilterComponent: false,
      isFilterActive: false,
      FilterComponent: VisitFilter,
    },
    {
      name: 'Patient',
      additionalContainerStyle: generateStyleObjectForTableColumn('Patient', isColumnTiles, isPast),
      additionalSpanStyle: generateStyleObjectForTableColumnSpan('Patient', isColumnTiles),
      isWithFilter: false,
      isShowFilterComponent: false,
      isFilterActive: false,
    },
    {
      name: 'Tags',
      additionalContainerStyle: generateStyleObjectForTableColumn('Tags', isColumnTiles, isPast),
      additionalSpanStyle: generateStyleObjectForTableColumnSpan('Tags', isColumnTiles),
      isWithIcon: true,
      isWithFilter: true,
      isFilterActive: false,
      isShowFilterComponent: false,
      FilterComponent: TagsFilter,
    },
    {
      name: 'Remarks',
      additionalContainerStyle: generateStyleObjectForTableColumn('Remarks', isColumnTiles, isPast),
      additionalSpanStyle: generateStyleObjectForTableColumnSpan('Remarks', isColumnTiles),
      isWithFilter: false,
      isFilterActive: false,
      isShowFilterComponent: false,
    },
    {
      name: 'Status',
      additionalContainerStyle: generateStyleObjectForTableColumn('Status', isColumnTiles, isPast),
      additionalSpanStyle: generateStyleObjectForTableColumnSpan('Status', isColumnTiles),
      isWithFilter: true,
      isShowFilterComponent: false,
      FilterComponent: StatusFilter,
      isFilterActive: false,
    },
  ]

  let correctVisitColumnsList = commonVisitColumnsList

  if (isPast) {
    correctVisitColumnsList = commonVisitColumnsList.filter(({ name }) => name !== 'Tags')
  }

  switch (type) {
    case 'upcomingCollapsed':
      return insert(correctVisitColumnsList.slice(0, 5), correctVisitColumnsList.slice(5), 5)
    case 'pastCollapsed':
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      return insert(correctVisitColumnsList.slice(0, 5), [].concat([], correctVisitColumnsList.slice(5)), 5)
    default:
      break
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateVisitTableRowStatus = (statusFromApi) => {
  switch (statusFromApi) {
    case visitListStatuses.IN_WAITING_ROOM:
      return visitListStatusesEncrypted.IN_WAITING_ROOM
    case visitListStatuses.IN_WAITING_ROOM_BACK:
      return visitListStatusesEncrypted.IN_WAITING_ROOM
    case visitListStatuses.IN_PROGRESS:
      return visitListStatusesEncrypted.IN_PROGRESS
    case visitListStatuses.UNRESOLVED:
      return visitListStatusesEncrypted.UNRESOLVED
    case visitListStatuses.RESOLVED:
      return visitListStatusesEncrypted.RESOLVED
    case visitListStatuses.CANCELED_BY_PATIENT:
      return visitListStatusesEncrypted.CANCELED_BY_PATIENT
    case visitListStatuses.SCHEDULED_BY_PATIENT:
      return visitListStatusesEncrypted.SCHEDULED_BY_PATIENT
    case visitListStatuses.RESCHEDULED_BY_PATIENT:
      return visitListStatusesEncrypted.RESCHEDULED_BY_PATIENT
    case visitListStatuses.ENDED:
      return visitListStatusesEncrypted.ENDED
    case visitListStatuses.SUCCESSFUL:
      return visitListStatusesEncrypted.SUCCESSFUL
    case visitListStatuses.CANCELED_BY_STAFF:
      return visitListStatusesEncrypted.CANCELED_BY_STAFF
    case visitListStatuses.SCHEDULED_BY_ADMIN:
      return visitListStatusesEncrypted.SCHEDULED_BY_ADMIN
    case visitListStatuses.RESCHEDULED_BY_ADMIN:
      return visitListStatusesEncrypted.RESCHEDULED_BY_ADMIN
    default:
      break
  }
}
